import { ReactElement, useMemo } from 'react';
import { Address } from 'viem';

import { useGetIpfsImageQuery } from 'modules/api/actions/getIpfsImage';
import { InfoCellContent } from 'modules/common/components/InfoCellContent';
import { isValidIpfsLink } from 'modules/common/components/IpfsImage';
import { Table } from 'modules/common/components/Table';
import { TableCellProps } from 'modules/common/components/Table/TableCell';
import { cropString } from 'modules/common/utils/cropString';
import { Status } from 'modules/pool/components/Status';
import { PoolStatus } from 'modules/pool/types';

interface IPoolNameCellProps extends TableCellProps {
  poolName?: string;
  poolLogoIpfsLink?: string;
  icon?: string;
  address: Address;
  delegators?: string;
  status?: PoolStatus;
}

export function PoolCell({
  poolName,
  poolLogoIpfsLink = '',
  icon,
  address,
  delegators,
  status,
  ...props
}: IPoolNameCellProps): ReactElement {
  const labels = useMemo(
    () => [cropString(address), delegators].filter(Boolean) as string[],
    [address, delegators],
  );

  const { data: image } = useGetIpfsImageQuery(
    { ipfsLink: poolLogoIpfsLink },
    { skip: !isValidIpfsLink(poolLogoIpfsLink) && !!icon },
  );

  return (
    <Table.Cell {...props}>
      <InfoCellContent
        additionalContent={status ? <Status status={status} /> : undefined}
        icon={icon ?? image}
        labels={labels}
        name={poolName}
      />
    </Table.Cell>
  );
}
